import { useState, useEffect } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import { useMutation } from '@apollo/client';
import { graphql } from '../../../gql';
import { useAuth } from '@calefy-inc/authentication';
import { BackendInsuranceCompany } from './PolicyStreamInsuranceCompanies';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { DisplayInlineError } from '../../common/ErrorHandling';
import { POLICYSTREAM_INSURANCE_COMPANIES } from './PolicyStreamInsuranceCompanies';

interface UpdateInsuranceCompanyProductsButtonProps {
  company: BackendInsuranceCompany;
}
export const UpdateInsuranceCompanyProductsButton = ({
  company,
}: UpdateInsuranceCompanyProductsButtonProps) => {
  const [errorDialogOpen, setErrorDialogOpen] = useState<boolean>(false);
  const { token } = useAuth();
  // @ts-expect-error
  const [updateInsuranceProducts, { loading, error, data }] = useMutation(
    UPDATE_INSURANCE_COMPANY_PRODUCTS,
    {
      refetchQueries: [
        { query: POLICYSTREAM_INSURANCE_COMPANIES, variables: { token } },
      ],
    },
  );

  useEffect(() => {
    if (error) {
      setErrorDialogOpen(true);
    }
  }, [error]);

  return (
    <>
      <LoadingButton
        loading={loading}
        onClick={() => {
          updateInsuranceProducts({
            variables: { token, companyId: company.id },
          });
        }}
      >
        Update Products
      </LoadingButton>
      <UpdateProductsErrorDialog
        open={errorDialogOpen}
        error={error}
        onClose={() => setErrorDialogOpen(false)}
      />
    </>
  );
};

interface UpdateProductsErrorDialog {
  error?: Error;
  open: boolean;
  onClose: () => void;
}
const UpdateProductsErrorDialog = ({
  error,
  open,
  onClose,
}: UpdateProductsErrorDialog) => {
  return (
    <Dialog open={open}>
      <DialogTitle>Error Updating Products</DialogTitle>
      <DialogContent>
        <DisplayInlineError error={error}>
          <Typography>Error when updating the products list:</Typography>
        </DisplayInlineError>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

const UPDATE_INSURANCE_COMPANY_PRODUCTS = graphql(`
  mutation updateInsuranceCompanyProducts($token: String!, $companyId: ID!) {
    updatePolicystreamInsuranceCompanyProducts(
      token: $token
      companyId: $companyId
    ) {
      products {
        id
        included
        name
      }
    }
  }
`);
